import React from 'react';

const HowWeHelpSection: React.FC = () => {
  const features = [
    {
      title: "Market Updates:",
      description: "Weekly videos dissecting mining market trends, from commodity price shifts to macroeconomic drivers."
    },
    {
      title: "Deep Dives:",
      description: "Case studies on successful juniors, revealing the due diligence that drives 10x returns."
    },
    {
      title: "Live Q&As:",
      description: "Direct access to Rob for insights on emerging opportunities."
    },
  ];

  const additionalFeatures = [
    {
      title: "Educational Resources:",
      description: "Courses on evaluating everything from drill results to NI 43-101 reports, timing catalysts, and managing risk, inspired by Rob’s decades of success."
    },
    {
      title: "Elite Collaboration:",
      description: "Connect with investors to share strategies and refine your approach, leveraging Mighty Networks’ seamless platform."
    },
    {
      title: "Exclusive Tools:",
      description: "Access proprietary checklists and frameworks to streamline your mining stock research."
    },
  ];

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#F6F6F6] pt-20 pb-20">
      <div className="">
        {/* Header */}
        <div className="text-left mb-16 w-full lg:w-2/3">
        <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
        Stay Ahead with Mining Stocks News
          </h2>
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0">
          Our Research Hub keeps you informed with the latest mining stocks news, curated to highlight critical developments. From exploration breakthroughs to financing deals, 
          <strong> we provide real-time updates that inform your speculation strategy. </strong>
          Whether it’s a lithium junior advancing in Quebec or a gold explorer in Nevada, 
          <strong> our mining market analysis ensures you’re positioned to act swiftly. </strong>
          <a 
            href="https://the-wealthy-miner.mn.co/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#D3A12A] hover:text-[#B8941F] transition-colors duration-300 underline"
          >
            <strong> Join our community to access:</strong>
          </a>
          </p>
        </div>

        {/* Feature Blocks */}
        <div className="space-y-6">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-[10px] p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex lg:items-start  items-center space-x-4">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center border-r border-[#D9D9D9] pr-4">
                    <img 
                      src="/images/deep.webp" 
                      alt="Feature icon" 
                      className=""
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-[13px] md:text-[18px] lg:text-[20px] font-[700] text-[#000] mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-[11px] md:text-[16px] lg:text-[16px] text-[#000] leading-[1.6] font-[400]">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Second Section Header */}
        <div className="text-left mb-16 w-full lg:w-2/3 mt-20">
          <h2 className="text-[25px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7 lg:text-left">
          The Path to Mastery
          </h2>
          <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#000] leading-[29px] font-[400] mb-4 last:mb-0">
          Becoming a master speculator requires more than data—it demands a sophisticated mindset. Our community equips you with:
          </p>
        </div>

        {/* Additional Feature Blocks */}
        <div className="space-y-6">
          {additionalFeatures.map((feature, index) => (
            <div key={index} className="bg-white rounded-[10px] p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex lg:items-start  items-center space-x-4">
                {/* Icon */}
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center border-r border-[#D9D9D9] pr-4">
                    <img 
                      src="/images/deep.webp" 
                      alt="Feature icon" 
                      className=""
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <h3 className="text-[13px] md:text-[18px] lg:text-[20px] font-[700] text-[#000] mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-[11px] md:text-[16px] lg:text-[16px] text-[#000] leading-[1.6] font-[400]">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelpSection;
